var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"inner"},[_c('Container',{attrs:{"containOn":"x"}},[_c('header',[_c('img',{attrs:{"src":require("@/assets/landing/images/logo.svg")}})]),_c('p',{staticClass:"landing-copy"},[_vm._v(" The Art Of Using Form To See Emptiness ")])]),_c('VimeoPlayer',{attrs:{"theme":"landing-loop","videoId":"504637617","options":{
        background: 0,
        autoplay: 1,
        controls: 0,
        loop: 1,
        muted: 1,
      }}}),_c('Container',{attrs:{"containOn":"x"}},[_c('nav',[_c('CustomLink',{attrs:{"theme":"ul-light-primary-pulse","to":"/explore-observatories"}},[_vm._v(" Explore The Observatories ")])],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }